import type { BlueprintAccessibilityIdentifierModifier } from '@/grove-blueprints/generated-types'

import type { ResolvedModifiers } from './resolve-modifiers'

export function resolveAccessibilityIdentifierModifier(
  modifier: BlueprintAccessibilityIdentifierModifier,
) {
  const attributes: ResolvedModifiers['attributes'] = {}

  attributes['data-testid'] = modifier.identifier

  return attributes
}
